import { httpDelete, httpDeleteWithPayload, httpGet, httpPost, httpPut } from '../../data'
import type {
  IDashboard,
  IDashboardEmbedConfig,
  IDashboardLink,
  IDashboardPayload,
  IDashboardResponse,
  IDashboardSingle,
  IDashboardTokens,
} from '../../../domain/interfaces/IDashboard'

export async function dashboardGetTokens() {
  return await httpGet<IDashboardTokens>('/dashboardTokens', true)
}

export async function dashboardGetEmbedTokens(config: IDashboardEmbedConfig) {
  return await httpPost<IDashboardTokens>('/domoEmbedTokens', config, {})
}

//Dashboards list
const dashboardsUrl = '/dashboards'

export async function orgDashboardLinksGet() {
  return await httpGet<IDashboardLink[]>('dashboardFolders', true)
  // res.right = [
  //   { id: '1', name: 'dashboard folder1' },
  //   { id: '2', name: 'dashboard f2' },
  // ]
  // res.right = []
}

export async function dashboardsGet(query?: string) {
  const url = query ? `${dashboardsUrl}?${query}` : dashboardsUrl
  return await httpGet<IDashboardResponse>(url, false)
}

export async function dashboardsGetOne(id?: string) {
  const url = `${dashboardsUrl}/${id}`
  return await httpGet<IDashboardSingle>(url, true)
}

export async function dashboardsPost(dashboardPayload: IDashboardPayload) {
  return await httpPost<IDashboard[]>(dashboardsUrl, dashboardPayload)
}

export async function putDashboard(id: string, dashboardPayload: IDashboardPayload) {
  return await httpPut<IDashboard>(`${dashboardsUrl}/${id}`, dashboardPayload, true)
}

export async function removeDashboard(id: string) {
  return await httpDelete<IDashboard>(`${dashboardsUrl}/${id}`, true)
}

export async function removeDashboards(ids: string[]) {
  return await httpDeleteWithPayload<IDashboard[]>(`${dashboardsUrl}/bulk`, { dashboardIds: ids }, true)
}

export async function toggleFavoriteDashboard(id: string, isFavorite: boolean) {
  if (isFavorite) {
    return await httpDelete<IDashboard>(`${dashboardsUrl}/removeFromFavorites/${id}`)
  } else {
    return await httpPost<IDashboard>(`${dashboardsUrl}/addToFavorites/${id}`, {})
  }
}

export async function toggleDefaultDashboard(id: string) {
  return await httpPost<IDashboard>(`${dashboardsUrl}/setAsDefault/${id}`, {})
}

export function sortFavoriteDashboards(dashboards: IDashboard[]): IDashboard[] {
  return dashboards
    .filter(dashboard => dashboard.isDefault || dashboard.isFavorited)
    .sort((a, b) => {
      // Sort by isDefault (true comes first)
      if (a.isDefault !== b.isDefault) {
        return a.isDefault ? -1 : 1
      }

      // If one is favorited and the other is not, favorited comes first
      if (a.isFavorited && !b.isFavorited) {
        return -1
      }
      if (!a.isFavorited && b.isFavorited) {
        return 1
      }

      // Both have same favorited status, sort alphabetically
      return a.name.localeCompare(b.name)
    })
}

/**
 * Sorts all items with isDefault first, then by favorited status, then alphabetically.
 * Keeps all items regardless of status.
 */
export function sortAllDashboardItems(dashboards: IDashboard[]): IDashboard[] {
  return dashboards.sort((a, b) => {
    // Sort by isDefault (true comes first)
    if (a.isDefault !== b.isDefault) {
      return a.isDefault ? -1 : 1
    }

    // If one is favorited and the other is not, favorited comes first
    if (a.isFavorited && !b.isFavorited) {
      return -1
    }
    if (!a.isFavorited && b.isFavorited) {
      return 1
    }

    // Both have same favorited status, sort alphabetically
    return a.name.localeCompare(b.name)
  })
}
